// extracted by mini-css-extract-plugin
export default {"containerIOSApp":"LWNWka"};